import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, Renderer2, ViewChild } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'projects/core/src/public-api';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { AppStateQuery } from '../../../data/app-state.query';
import { AppStateStore } from '../../../data/app-state.store';
import { UserProfile } from 'projects/app-misc/src/app/modules/profile/utils/profile.utils';

@Component({
	selector: 'app-profile-edit',
	templateUrl: './profile-edit.component.html',
	styleUrls: ['./profile-edit.component.scss']
})
export class ProfileEditComponent implements OnInit {
	currentUser: User;

	temporaryName: string;

	temporaryPhone: string;

	temporaryEmail: string;

	password: string;

	authorized$ = this.appStateQuery.authorized$;

	userProfile: UserProfile

	constructor(
		protected dialog: MatDialog,
		protected loginService: LoginService,
		protected userService: UserService,
		protected viewContainerRef: ViewContainerRef,
		protected renderer: Renderer2,
		protected appStateStore: AppStateStore,
		protected appStateQuery: AppStateQuery
	) { }

	ngOnInit() {
		this.authorized$
			.subscribe(authorized => {
				if (authorized) {
					this.currentUser = this.loginService.currentUser

					this.appStateQuery.userProfile$.subscribe(userProfile => this.userProfile = userProfile)
				}
			})
		this.temporaryName = this.currentUser.name
		this.temporaryPhone = this.currentUser.phone
		this.temporaryEmail = this.currentUser.email
	}

	saveUserData() {
		const userData = {
			id: this.currentUser.id,
			name: this.temporaryName,
			phone: this.temporaryPhone,
			email: this.temporaryEmail
		}
		this.userService
			.saveUser(userData)
			.subscribe(updatedUser => {
				this.currentUser = updatedUser
				this.appStateStore.updateCurrentUser(this.currentUser)
				this.dialog.closeAll();
			})

	}

	openChangePasswordDialog(): void {
		// this.sendData.emit(this.currentUser)
		const cpDialogRef = this.dialog.open(ChangePasswordDialogComponent, {
			panelClass: 'change-password-dialog'
		});
		cpDialogRef.afterOpened().subscribe(() => {
			this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
		})
		cpDialogRef.afterClosed().subscribe(() => {
			this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
		})

	}

	changePhoto() {

	}
}